import React, {useState} from 'react'
import arrowLeft from '../../assets/icons/arrow-left.svg'
import DetailProfile from '../../components/kehadiran/DetailProfile'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {useEffect} from 'react'
import dayjs from 'dayjs'
import Sidebar from '../../components/sidebar/Sidebar'
import DetailCard from '../../components/kehadiran/DetailCard'
import pdfIcon from '../../assets/icons/pdf.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
    getDetailJurnal,
    resetDetail,
    updateStateDetailJurnal
} from '../../features/jurnalDetailSlice'
import LoadingFullscreen from '../../components/LoadingFullscreen'
import InfoBox from '../../components/InfoBox'
import {goBack} from '../../utils/goBack'
import JurnalDetailCard from "../../components/jurnal/jurnalDetailCard";
import imgErrorValidation from "../../utils/imgErrorValidation";
import DisplayKategoriList from "../../components/DisplayKategoriList";
import copy from "../../assets/icons/copy.svg";
import edit from "../../assets/icons/edit.svg";
import trash from "../../assets/icons/trashRed.svg";
import useImgError from "../../utils/imgErrorValidation";
import Rating from "react-rating";
import ReactStars from "react-stars";


function JurnalDetail() {
    let userId = useParams()
    const dispatch = useDispatch()

    const [popUpMasuk, setPopUpMasuk] = useState(false);
    const [popUpKeluar, setPopUpKeluar] = useState(false);
    const [popUpMapMasuk, setPopUpMapMasuk] = useState(false);
    const [popUpMapKeluar, setPopUpMapKeluar] = useState(false);
    const {
        loading,
        detailData,
        statusResApi,
        messageResApi,
        isDisplayMessage
    } = useSelector(State => State.jurnalDetail)

    useEffect(() => {
        dispatch(resetDetail())
    }, [])

    useEffect(() => {

        dispatch(getDetailJurnal(userId.id))

    }, [userId]);

    function checkNull(data) {
        return data ? data : '-'
    }

    function isLinkPdfOrImage(link) {
        const pdfExtensions = ['.pdf'];
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];

        const extension = link.substring(link.lastIndexOf('.')).toLowerCase();

        if (pdfExtensions.includes(extension)) {
            return 'pdf';
        } else if (imageExtensions.includes(extension)) {
            return 'image';
        } else {
            return 'unknown';
        }
    }

    function tipeIzin(tipe) {
        if (tipe === "Sakit") {
            return "S"
        } else if (tipe === "Izin") {
            return "I"
        } else {
            return "A"
        }
    }


    return (
        <div className='wrapper-detail'>
            <Sidebar/>
            <div className='detail'>
                <div className='navigation'>
                    <img onClick={goBack} src={arrowLeft} alt=""/>
                    <h1>Detail Jurnal</h1>
                </div>

                <div className='main'>
                    {detailData?.jenis_izin === undefined &&
                        <div className='detail-masuk-keluar' style={{display: 'block'}}>

                            <div className='detail-masuk-keluar' style={{width:'100%',padding:'0',margin:'0'}}>
                                <JurnalDetailCard
                                    type='Jurnal'
                                    tanggal={detailData?.tanggal_masuk}
                                    waktu={detailData?.waktu_masuk}
                                    link_foto={detailData?.link_foto_masuk}
                                    catatan={detailData?.note}
                                    status={detailData?.status}
                                    latitude={detailData?.latitude_masuk}
                                    longitude={detailData?.longitude_masuk}
                                    is_valid={detailData?.is_valid_masuk}
                                    is_valid_wkt={detailData?.isvld_wkt_masuk}
                                    loading={loading}
                                    popUp={popUpMasuk}
                                    setPopUp={setPopUpMasuk}
                                    popUpMap={popUpMapMasuk}
                                    setPopUpMap={setPopUpMapMasuk}
                                    checkNull={checkNull}
                                    keterangan={detailData?.keterangan}
                                />

                                <div className='masuk-keluar'>
                                    <div className='jam-masuk'>
                                        <h3>Absensi Murid</h3>
                                    </div>

                                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px',}}>
                                        {

                                            detailData.siswa?.length === 0 ? <tr className='loading-table'>
                                                    <td>Tidak ada siswa Absen</td>
                                                </tr> :
                                                detailData.siswa?.map((item, key) => {
                                                    return (
                                                        <div style={{

                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '20px',
                                                            border: '1px solid #ebf0fe',
                                                            borderRadius: '10px',
                                                            alignItems: 'center',
                                                            height: '65px',


                                                        }}>

                                                            <div>
                                                                <h3 style={{

                                                                    fontSize: "14px",
                                                                    fontWeight: "600",
                                                                    marginBottom: "0.4rem"

                                                                }}>{item.student_name.nama}</h3>
                                                                <p

                                                                    style={{

                                                                        fontSize: "10px",
                                                                        color: "#9b9b9b",


                                                                    }}
                                                                >{checkNull(item.note)}</p>
                                                            </div>

                                                            <div style={
                                                                {
                                                                    backgroundColor: 'rgba(39,127,254,0.1)',
                                                                    width: '29px',
                                                                    height: '24px',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    borderRadius: '5px',
                                                                    alignItems: 'center',

                                                                }
                                                            }>
                                                                <p style={
                                                                    {
                                                                        color: '#277FFE',
                                                                        fontWeight: 600,
                                                                        fontSize: '12px',
                                                                    }
                                                                }>{tipeIzin(item.tipe_izin)}</p>
                                                            </div>

                                                        </div>
                                                    )
                                                })

                                        }

                                    </div>


                                </div>
                            </div>


                            <div>

                                <div className='masuk-keluar' style={{width: '100%',marginTop: '25px'}}>
                                    <div className='jam-masuk'>
                                        <h3>Rating Murid</h3>

                                        <div style={
                                            {
                                                backgroundColor: 'rgba(39,127,254,0.1)',
                                                width: '29px',
                                                height: '24px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                borderRadius: '5px',
                                                alignItems: 'center',

                                            }
                                        }>
                                            <p style={
                                                {
                                                    color: '#277FFE',
                                                    fontWeight: 600,
                                                    fontSize: '12px',
                                                }
                                            }>{   detailData.student_ratings?.length === 0 ?"0":   detailData.student_ratings?.length}</p>
                                        </div>
                                    </div>

                                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px',}}>
                                        {

                                            detailData.student_ratings?.length === 0 ? <tr className='loading-table'>
                                                    <td>Tidak ada siswa Rating</td>
                                                </tr> :
                                                detailData.student_ratings?.map((item, key) => {
                                                    return (
                                                        <div style={{

                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '20px',
                                                            border: '1px solid #ebf0fe',
                                                            borderRadius: '10px',
                                                            alignItems: 'center',
                                                            height: '65px',


                                                        }}>

                                                            <div>
                                                                <h3 style={{

                                                                    fontSize: "14px",
                                                                    fontWeight: "600",
                                                                    marginBottom: "0.4rem"

                                                                }}>{item.student.nama}</h3>
                                                                <p

                                                                    style={{

                                                                        fontSize: "10px",
                                                                        color: "#9b9b9b",


                                                                    }}
                                                                >{checkNull(item.note)}</p>
                                                            </div>




                                                                    <ReactStars count={5} value={item.rating} size={15}
                                                                                color2={"#ffd700"}/>



                                                        </div>
                                                    )
                                                })

                                        }

                                    </div>


                                </div>
                            </div>

                        </div>


                    }


                    <div className='detail-profile'>
                        <div className='div-1'>
                            <h1>Foto Profile</h1>
                            <img src={detailData?.user?.link_foto} onError={useImgError} alt=""/>
                            <h3>{checkNull(detailData?.user?.nama)}</h3>
                            {
                                detailData?.user?.rating?.status === true ?
                                    <ReactStars count={5} value={detailData?.user?.rating?.data} size={25}
                                                color2={"#ffd700"}/>
                                    :
                                    <p>{detailData?.user?.rating?.note}</p>
                            }
                        </div>
                        <div className='div-2'>
                            <div className='info'>
                                <h3>Kelas</h3>
                                <p>{checkNull(detailData?.user?.kelas)}</p>
                            </div>
                            <div className='info'>
                                <h3>Mapel</h3>
                                <p>{checkNull(detailData?.user?.mapel)}</p>
                            </div>
                            <div className='info'>
                                <h3>Tanggal</h3>
                                <p>{checkNull(detailData?.tanggal_jurnal)}</p>
                            </div>
                            <div className='info'>
                                <h3>Jam Pelajaran</h3>
                                <p>{checkNull(detailData?.user?.jam_masuk)}</p>
                            </div>
                            <div className='info'>
                                <h3>Tipe Jurnal</h3>
                                <p>{checkNull(detailData?.user?.tipe_jurnal)}</p>
                            </div>
                        </div>

                        <div className='info' style={{width: '100%'}}>
                            <h3>Keterangan Jurnal:</h3>

                            <div style={{border: '1px solid #ECEEF2',padding: '10px',borderRadius: '5px',marginTop: '10px',height: '90px'}}>

                                <p className={'note'}>{checkNull(detailData?.keterangan_jurnal)}</p>

                            </div>

                        </div>


                        <div className='back-btn' style={{  marginTop: "3.25rem"}} onClick={goBack}>Kembali</div>
                    </div>
                </div>
            </div>
            <LoadingFullscreen loading={loading}/>
            <InfoBox
                isDisplay={isDisplayMessage}
                message={messageResApi}
                status={statusResApi}
                setIsDisplay={updateStateDetailJurnal}
                stateName={'isDisplayMessage'}
            />
        </div>
    )
}

export default JurnalDetail